import api from '../../../../services/api';
import {
  setShopifyProducts,
  setFilteredShopifyProducts,
  setLoading,
  setError,
  setPagination,
  setFilters
} from '../reducers';

// Hàm lấy danh sách Shopify Products từ API với phân trang
export const fetchShopifyProducts = (page = 1, pageSize = 50) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  try {
    // Lấy thông tin filter hiện tại
    const { filters } = getState().shopifyProducts;

    // Tạo query params cho API request
    const queryParams = new URLSearchParams();
    queryParams.append('page', page);
    queryParams.append('pageSize', pageSize);

    // Thêm các filter vào query params nếu có
    if (filters.searchText) {
      queryParams.append('searchText', filters.searchText);
    }

    if (filters.selectedStatus && filters.selectedStatus !== 'all') {
      queryParams.append('status', filters.selectedStatus);
    }

    if (filters.selectedShopifyStore && filters.selectedShopifyStore !== 'all') {
      queryParams.append('shopifyStoreId', filters.selectedShopifyStore);
    }

    // Gọi API với các tham số phân trang và lọc
    const response = await api.get(`/shopify/products?${queryParams.toString()}`);
    
    // Xử lý kết quả trả về
    if (response.data) {
      dispatch(setShopifyProducts(response.data.rows));
      dispatch(setPagination({
        current: response.data.pagination.page,
        pageSize: response.data.pagination.pageSize,
        total: response.data.pagination.total
      }));
    }
  } catch (error) {
    console.error('Error fetching Shopify products:', error);
    dispatch(setError('Không thể lấy danh sách Shopify products'));
  } finally {
    dispatch(setLoading(false));
  }
};

// Hàm áp dụng bộ lọc và tải lại dữ liệu
export const applyFilters = (searchText, selectedStatus, selectedShopifyStore) => (dispatch, getState) => {
  // Lưu các filter mới
  dispatch(setFilters({ searchText, selectedStatus, selectedShopifyStore }));
  
  // Tải lại dữ liệu với filter mới và reset về trang đầu tiên
  dispatch(fetchShopifyProducts(1, getState().shopifyProducts.pagination.pageSize));
};

// Hàm xử lý khi thay đổi trang hoặc kích thước trang
export const onChangePagination = (page, pageSize) => (dispatch) => {
  dispatch(fetchShopifyProducts(page, pageSize));
};

// Hàm xem chi tiết Shopify Product
export const viewShopifyProductDetail = (id, navigate) => () => {
  navigate(`/shopify/products/${id}`);
};

// Hàm chỉnh sửa Shopify Product
export const editShopifyProduct = (id, navigate) => () => {
  navigate(`/shopify/products/${id}/edit`);
};

// Hàm xóa Shopify Product
export const deleteShopifyProduct = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/shopify/products/${id}`);
    // Tải lại dữ liệu sau khi xóa
    dispatch(fetchShopifyProducts(
      getState().shopifyProducts.pagination.current,
      getState().shopifyProducts.pagination.pageSize
    ));
    return { success: true, message: 'Shopify Product đã được xóa thành công' };
  } catch (error) {
    return { success: false, message: 'Lỗi khi xóa Shopify Product' };
  }
};

// Hàm đồng bộ Shopify Products
export const syncShopifyProducts = (submitData) => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    await api.post('/shopify/products/sync', submitData);
    // Tải lại danh sách sau khi đồng bộ
    dispatch(fetchShopifyProducts(1));
    return { success: true, message: 'Đồng bộ Shopify Products thành công!' };
  } catch (error) {
    console.error('Error syncing Shopify products:', error);
    dispatch(setError('Không thể đồng bộ Shopify Products'));
    return { success: false, message: 'Lỗi khi đồng bộ Shopify Products' };
  } finally {
    dispatch(setLoading(false));
  }
};

// Cập nhật trạng thái của Shopify Product
export const updateShopifyProductStatus = (id, status) => async (dispatch, getState) => {
  try {
    await api.put(`/shopify/products/${id}`, { status });
    // Tải lại dữ liệu sau khi cập nhật
    dispatch(fetchShopifyProducts(
      getState().shopifyProducts.pagination.current,
      getState().shopifyProducts.pagination.pageSize
    ));
    return { success: true, message: 'Trạng thái Shopify Product đã được cập nhật thành công' };
  } catch (error) {
    return { success: false, message: 'Lỗi khi cập nhật trạng thái Shopify Product' };
  }
};
